import React, { useState, useEffect, Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { getRUCEmpresa } from "../../../redux/actions/userActions";
//componentes del sistema
import TablePaginatedVoucher from "../../../widgets/Tables/TablePaginatedVoucher";
import {
  API_GET_VOUCHER_NOAUTHORIZED,
  API_GET_SEARCH_NOAUTHORIZED,
} from "./apis";
import tableStyle from "../../../configurations/styles/table";
import SearchVoucher from "../Forms/SearchVoucher";
import { Grid, Button, CircularProgress } from "@material-ui/core";
import ErrorMsgBtn from "./Buttons/ErrorMsgBtn";
import TablePaginatedVoucherSearch from "widgets/Tables/TablePaginatedVoucherSearch";
import TablePaginatedSearchVoucher from "widgets/Tables/TablePaginatedSearchVoucher";
import ViewerVoucherBtn from "../AuthorizedIssuedVouchers/Buttons/ViewerVoucherBtn";
import { AuthorizedIssuedVouchersProvaider } from '../AuthorizedIssuedVouchers/Context';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: "50px",
    flexGrow: 1,
    paddingLeft: "3%",
    paddingRight: "3%",
    marginBottom: "5%",
  },
}));

const NoAuthorizedVoucher = () => {
  const tokenUser = useSelector((state) => state.user.tk);
  const ruc = tokenUser ? getRUCEmpresa(tokenUser) : null;
  const rucAvailablesToCufePo = ["155754584-2-2024"];
  const rowsOptions = rucAvailablesToCufePo.includes(ruc)
    ? [5, 10, 15, 50, 100, 500]
    : [5, 10, 15];
  const classesView = useStyles();
  //Para controlar la actualización de la vista
  const [update, setUpdate] = useState(1);
  const [paramSearch, setParamSearch] = useState("");
  //State para la búsqueda
  const [foundVouchers, setfoundVouchers] = useState([]);

  const columns = [
    {
      title: "Número",
      field: "comprobanteElectronico.secuencial",
      cellStyle: tableStyle.cellTable,
      width: "10%",
      render: (rowData) =>
        `${rowData.comprobanteElectronico.codigoSucursal}-${rowData.comprobanteElectronico.puntoFacturacion}-${rowData.comprobanteElectronico.numeroFactura}`,
    },
    {
      title: "Fecha Emisión",
      field: "comprobanteElectronico.fechaEmision",
      cellStyle: tableStyle.cellTable,
      width: "10%",
      render: (rowData) =>
        rowData.comprobanteElectronico.fechaEmision.substring(0, 10),
    },
    {
      title: "Receptor",
      field: "nombreReceptor",
      cellStyle: tableStyle.cellLeft,
    },
    {
      title: "Tipo",
      field:
        "comprobanteElectronico.tipoComprobanteElectronico.nombreComprobante",
      cellStyle: tableStyle.cellTable,
      width: "12%",
      render: (rowData) =>
        rowData.comprobanteElectronico.tipoComprobanteElectronico.nombreComprobante.replace(
          "_",
          " DE "
        ),
    },
    ...(rucAvailablesToCufePo.includes(ruc)
    ? [{
        title: "PO",
        field: "comprobanteElectronico.uid",
        cellStyle: tableStyle.cellTable,
        width: "12%",
        render: (rowData) =>
          rowData.comprobanteElectronico.uid
      }]
    : []),
    {
      title: "Valor",
      field:
        "comprobanteElectronico.tipoComprobanteElectronico.nombreComprobante",
      cellStyle: tableStyle.cellTable,
      width: "12%",
      render: (rowData) =>
        "$ ".concat(rowData.comprobanteElectronico.valorTotal),
    },
    {
      title: "Ver",
      cellStyle: tableStyle.cellTable,
      width: "5%",
      render: (rowData) => (
        <ViewerVoucherBtn
          iDoc={
            rowData.comprobanteElectronico.tipoComprobanteElectronico
              .codigoComprobante
          }
          txt={"Visualizar CAFE"}
          voucher={rowData}
        />
      ),
    },
    //{ title: 'XML', cellStyle: tableStyle.cellTable, width: '5%', render: rowData => <XMLVoucherBtn voucher={rowData} /> },
    {
      title: "Error",
      cellStyle: tableStyle.cellTable,
      width: "5%",
      render: (rowData) => <ErrorMsgBtn voucher={rowData} />,
    },
  ];

  const requestConfig = {
    uri:
      API_GET_VOUCHER_NOAUTHORIZED +
      (tokenUser ? getRUCEmpresa(tokenUser) : "0"),
    metodo: "get",
    body: null,
    page: 0,
    elementos: 15,
    sort: "idAsignacionComprobanteElectronico,desc",
  };

  const requestConfigSeacrh = {
    uri: `${API_GET_SEARCH_NOAUTHORIZED}${
      tokenUser ? getRUCEmpresa(tokenUser) : "0"
    }`,
    metodo: "get",
    body: null,
    page: 0,
    elementos: 15,
    sort: "idAsignacionComprobanteElectronico,desc",
  };

  useEffect(() => {}, [update]);

  const headerBottons = () => {
    if (update === 6) {
      return (
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
        >
          <Grid item xs={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setUpdate(1)}
            >
              Mostrar Todos
            </Button>
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid>
      );
    }
  };

  const renderTable = () => {
    switch (update) {
      case 1:
        setUpdate(2);
        return (
          <div align="center">
            <CircularProgress />
          </div>
        );
      case 2:
        return (
          <TablePaginatedVoucher
            title=""
            numeroFilas={5}
            columns={columns}
            requestConfig={requestConfig}
            BotonesHeader={headerBottons}
            seleccion={false}
            rowsPerPageOptions={rowsOptions}
          />
        );
      case 3:
        return (
          <Fragment>
            <TablePaginatedVoucherSearch
              title=""
              columns={columns}
              numeroFilas={5}
              requestConfig={requestConfigSeacrh}
              BotonesHeader={headerBottons}
              paramSearch={paramSearch}
              seleccion={false}
              rowsPerPageOptions={rowsOptions}
            />
          </Fragment>
        );
      case 4:
        return (
          <Fragment>
            <TablePaginatedSearchVoucher
              title=""
              columns={columns}
              numeroFilas={5}
              requestConfig={requestConfigSeacrh}
              BotonesHeader={headerBottons}
              paramSearch={paramSearch}
              seleccion={false}
              rowsPerPageOptions={rowsOptions}
            />
          </Fragment>
        );
      default:
        break;
    }
  };

  return (
    <AuthorizedIssuedVouchersProvaider> 
      <div className={classesView.root}>
        <SearchVoucher
          update={update}
          setUpdate={setUpdate}
          setParamSearch={setParamSearch}
          rucEnterprise={ruc}
        />
        {renderTable()}
        <br></br>
      </div>
    </AuthorizedIssuedVouchersProvaider> 
  );
};
export default NoAuthorizedVoucher;
